/**
 * Performs a fuzzy match on two strings. Returns true if the needle is found in
 * the haystack ignoring case
 * @param needle
 * @param haystack
 * @return boolean
 */
export const fuzzyMatch = (needle: string, haystack: string): boolean => {
    return haystack
        .toLocaleLowerCase()
        .indexOf(needle.toLocaleLowerCase()) !== -1;
};



// WEBPACK FOOTER //
// ./src/app/helpers/fuzzy-match.ts